module.exports = __webpack_public_path__ + "img/Association_VPA_5.f0cf920a.jpg";